import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { store, persistor } from "./store";
import { Provider } from "react-redux";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import { PersistGate } from 'redux-persist/integration/react'; // Import PersistGate

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <React.StrictMode>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
  </React.StrictMode>,
);
serviceWorkerRegistration.unregister();
reportWebVitals();
